export const regexes = {
  firstAndLastNameRegx: '^(?![\\s.]+$)[a-zA-Z\\s.]*$',
  phoneNumber: '[0-9]{5,}',
  deepLinkPathRegex: new RegExp('^/requests/(0|[1-9][0-9]*)$'),
  email: new RegExp(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/),
  bnyMellonDomainRegex:new RegExp(/^[A-Za-z0-9._%+-]+@bnymellon\.com$/)
};
